export type AuthTabId = 'sms' | 'call' | 'email';

export type AuthSmsActionId = 'telegram';

export type AuthFormMethodId = AuthTabId | AuthSmsActionId;

export type AuthRedirectId = 'tinkoff' | 'max';

export type AuthFormMethod = {
  id: AuthFormMethodId;
  role: 'tab' | 'sms-action';
};

export type AvailableAuthMethods = {
  form: AuthFormMethod[];
  redirects: AuthRedirectId[];
};

export const AUTH_TABS: {
  id: AuthTabId;
  label: string;
  index: number;
}[] = [
  { id: 'sms', label: 'СМС', index: 0 },
  { id: 'call', label: 'Звонок', index: 1 },
  { id: 'email', label: 'Email', index: 2 }
];

const HARDCODED_FORM_METHODS: AuthFormMethod[] = [
  { id: 'sms', role: 'tab' },
  { id: 'call', role: 'tab' },
  { id: 'email', role: 'tab' },
  { id: 'telegram', role: 'sms-action' }
];

const HARDCODED_REDIRECTS: AuthRedirectId[] = ['max'];

export const getAvailableAuthMethods = (
  isTinkoffEnabled: boolean
): AvailableAuthMethods => {
  const redirects = HARDCODED_REDIRECTS.slice();
  if (isTinkoffEnabled) {
    redirects.unshift('tinkoff');
  }
  return {
    form: HARDCODED_FORM_METHODS.slice(),
    redirects
  };
};
